import React from "react";
import styled from "styled-components";
import { color } from "src/styles/variables";

function OutOfStock({ ...props }) {
  return <OutOfStockLabel {...props}>Out of stock</OutOfStockLabel>;
}

export default OutOfStock;

const OutOfStockLabel = styled.p`
  margin-bottom: 0;
  background-color: ${color.shipGrey};
  color: ${color.silverChalice};
  padding: 5px 10px;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 13px;
  align-self: flex-start;
  display: inline-block;
`;
